module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-posts-list js-x-scroll-target-lg"
  }, [_vm._l((_vm.posts), function(post) {
    return [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      key: post.uid,
      class: ("c-post-card c-post-card--" + (_vm.toCssName(post.data.category))),
      attrs: {
        "id": post.uid
      }
    }, [_c('router-link', {
      staticClass: "c-post-card__link",
      attrs: {
        "to": {
          name: 'post',
          params: {
            id: post.uid
          }
        }
      }
    }, [(post.data.featured_image.url) ? _c('div', {
      staticClass: "c-post-card__media"
    }, [_c('img', {
      staticClass: "c-post-card__image",
      attrs: {
        "src": post.data.featured_image.url,
        "alt": post.data.featured_image.alt,
        "width": _vm.getWidth(post.data.featured_image),
        "height": _vm.getHeight(post.data.featured_image)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "c-post-card__content"
    }, [_c('h4', {
      staticClass: "c-posts-card__meta-category",
      domProps: {
        "innerHTML": _vm._s(post.data.category)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-post-card__title-wrapper"
    }, [_c('h3', {
      staticClass: "c-post-card__title",
      domProps: {
        "innerHTML": _vm._s(_vm.getTextContent(post.data.title))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-post-card__lead",
      domProps: {
        "textContent": _vm._s(_vm.getTextContent(post.data.subtitle))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "c-post-card__btn"
    }, [_vm._v("Read More")])])])])], 1)])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248117e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostsList.vue
// module id = 74
// module chunks = 0